"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForExpectedValue = exports.removeNullish = exports.filterNullish = exports.convertObservableToBehaviorSubject = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
/**
 * Converts an Observable to a BehaviorSubject, can be used via the `convertToSubject` angular pipe.
 */
function convertObservableToBehaviorSubject(observable, initValue) {
    const subject = new rxjs_1.BehaviorSubject(initValue);
    void observable.subscribe((value) => subject.next(value), (error) => subject.error(error), () => subject.complete());
    return subject;
}
exports.convertObservableToBehaviorSubject = convertObservableToBehaviorSubject;
/**
 * Filters null and undefined values while indicating to TypeScript that these vales are no longer possible.
 */
function filterNullish() {
    return (0, rxjs_1.pipe)((0, operators_1.filter)((x) => x !== null && x !== undefined));
}
exports.filterNullish = filterNullish;
/**
 * Removes null and undefined values recursively from an object
 */
function removeNullish(obj, options = { removeEmptyStrings: false }) {
    if (obj === undefined || obj === null)
        return obj;
    for (const key in obj) {
        if (obj[key] === null ||
            obj[key] === undefined ||
            (options.removeEmptyStrings === true && obj[key] === ""))
            delete obj[key];
        if (typeof obj[key] === "object")
            removeNullish(obj[key]);
    }
    return obj;
}
exports.removeNullish = removeNullish;
/**
 * Will resolve when the expected value is emitted by the observable
 *
 * @param observable The observable
 * @param expectedValue Defaults to the boolean value `true`
 * @returns Resolves when the expected value was emitted at least once
 */
function waitForExpectedValue(observable, expectedValue) {
    if (expectedValue === undefined)
        expectedValue = true;
    return new Promise((resolve) => {
        void observable
            .pipe((0, operators_1.first)((val) => val === expectedValue), (0, operators_1.take)(1), (0, operators_1.tap)(() => resolve()))
            .subscribe();
    });
}
exports.waitForExpectedValue = waitForExpectedValue;
